import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URLS } from "./apis/urls";
import Api from "./utils/apiCall";

interface UsersState {
  users: any;
  loading: "idle" | "pending" | "fulfilled" | "rejected";
  error: string | null;
  action: "list" | "save" | null;
}

const initialState: UsersState = {
  users: null,
  loading: "idle",
  error: null,
  action: null,
};

export const getUsersList: any = createAsyncThunk(
  "fetch/usersList",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.USERS.LIST, payload);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const addUser: any = createAsyncThunk(
  "add/user",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.USERS.ADD, payload);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

const usersSlice = createSlice({
  name: "reset",
  initialState: initialState,
  reducers: {
    resetAll: (state: any) => {
      state.loading = "idle";
      state.error = null;
      state.users = null;
      state.action = null;
    },
  },
  extraReducers: (builder) => {


    builder.addCase(getUsersList.pending, (state) => {
      state.loading = "pending";
      state.users = null;
      state.error = null;
      state.action = "list";
    });
    builder.addCase(getUsersList.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.users = action.payload;
      state.error = null;
      state.action = "list";
    });
    builder.addCase(getUsersList.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.users = null;
    });


    builder.addCase(addUser.pending, (state) => {
      state.loading = "pending";
      state.users = null;
      state.error = null;
      state.action = "save";
    });
    builder.addCase(addUser.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.users = action.payload;
      state.error = null;
      state.action = "save";
    });
    builder.addCase(addUser.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.users = null;
      state.action = "save";
    });


  },
});

export const { resetAll } = usersSlice.actions;
export default usersSlice.reducer;
